import React from "react";
import { useTranslation } from "react-i18next";
import { Box, Dialog, Typography } from "@mui/material";
import { MyHrChangePasswordForm } from "my-hr/forms";
import { OcTransition } from "oc/components";

type MyHrChangeTemporaryPasswordDialogProps = {
  onLogout: () => void;
  open: boolean;
};

export const MyHrChangeTemporaryPasswordDialog = ({
  onLogout,
  open,
}: MyHrChangeTemporaryPasswordDialogProps) => {
  const { t } = useTranslation();
  return (
    <Dialog
      open={open}
      TransitionComponent={OcTransition}
      sx={{ zIndex: 30000 }}
      BackdropProps={{
        style: {
          width: "100%",
          backgroundColor: "rgba(0,0,0,0.7",
          backgroundImage: "url(/img/loginBg.jpg)",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
          backgroundBlendMode: "darken",
        },
      }}
    >
      <Box
        display="flex"
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="100%"
      >
        <Box width="480px" padding="36px 24px">
          <Typography variant="h6" align="center">
            {t("MY_HR_CHANGE_PASSWORD")}
          </Typography>
          <Box padding="32px 0px 8px 0px" style={{ color: "#5e6366" }}>
            <Box height="20px" />
          </Box>
          <MyHrChangePasswordForm onLogout={onLogout} />
        </Box>
      </Box>
    </Dialog>
  );
};

export default MyHrChangeTemporaryPasswordDialog;
